export default __webpack_public_path__ + "static/media/job_offer9_s.483e0907.jpg";